document.addEventListener("DOMContentLoaded", () => {
  const shelfFilterSlider = document.querySelector(
    ".productShelfSlider-filters",
  );

  if (shelfFilterSlider) {
    new Swiper(`.productShelfSlider-filters`, {
      slidesPerView: "auto",
      spaceBetween: 8,
      freeMode: true,
      centerInsufficientSlides: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      grabCursor: true,
      slidesPerGroupAuto: "auto",
      touchEventsTarget: "container",
      touchReleaseOnEdges: true,
      watchOverflow: true,
      navigation: {
        nextEl: ".productShelfSlider-filters-chev-r",
        prevEl: ".productShelfSlider-filters-chev-l",
        disabledClass: "opacity-0",
      },
    });
  }
});
